<template>
  <div class="content_top d-flex flex-column">
    <Vue-header> </Vue-header>
    <!--ログイン画面と管理画面に遷移-->
    <div class="content">
      <RouterView />
    </div>
    <VueFooter></VueFooter>
  </div>
</template>

<script setup>
import { RouterView } from "vue-router";

import VueHeader from "./components/header.vue";
import VueFooter from "./components/footer.vue";

const url = new URL(window.location.href);
console.log(url);
</script>

<style>
body,
html {
  display: block !important;
  padding: 0;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  height: 100%;
}
.content_top {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  height: 100%;
}

.content {
  flex-grow: 1;
  box-sizing: border-box;
  min-height: 100%;
  /*
    padding-top: 75px;
    padding-bottom: 125px;
    */
}
</style>
